module.exports = __webpack_public_path__ + "img/icone_casa_home_school.a9914266.svg";